import axios from 'axios'
import postcss from 'postcss'

import {
  getDefaultThemeSettings,
  getThemeMeta,
  getThemeSettings,
  getThemeSettingsSchema,
  setTheme,
  setThemeVariablesCss,
} from './shop'
import { getThemeStylesheetPath } from '../../../utils/themes'
import { setHasThemeLoaded } from './view'
import postcssExtractVariableRules from '../../../utils/postcssExtractVariableRules'

export type ThemeActionTypes = SwitchTheme | SwitchThemeSuccess | SwitchThemeFailure

const variableExtractor = postcss([postcssExtractVariableRules()])

type SwitchTheme = { type: typeof SWITCH_THEME }
type SwitchThemeSuccess = { type: typeof SWITCH_THEME_SUCCESS; themeId: string }
type SwitchThemeFailure = { type: typeof SWITCH_THEME_FAILURE; errorMessage: string }

export const SWITCH_THEME = 'SWITCH_THEME'
export const SWITCH_THEME_SUCCESS = 'SWITCH_THEME_SUCCESS'
export const SWITCH_THEME_FAILURE = 'SWITCH_THEME_FAILURE'
export function switchTheme(theme: Core.Theme): GlobalAction {
  return async function switchTheme(dispatch) {
    try {
      dispatch({ type: SWITCH_THEME })
      dispatch(setHasThemeLoaded(false))

      // Activate the theme on the shop
      await dispatch(setTheme(theme.id))

      const themeStylesheetPath = getThemeStylesheetPath(theme.name)

      // Update theme variables for theme settings live preview in editor
      const { data } = await axios.get<string>(`${themeStylesheetPath}?raw`)
      dispatch(setThemeVariablesCss(variableExtractor.process(data, { from: undefined }).css))

      // Swap the currently used theme stylesheet
      // and load all related data for the switched to theme
      await Promise.all([
        loadThemeStylesheet(themeStylesheetPath),
        ...[getDefaultThemeSettings, getThemeSettings, getThemeSettingsSchema, getThemeMeta].map((action) =>
          dispatch(action(theme.id)),
        ),
      ])

      dispatch({ type: SWITCH_THEME_SUCCESS, themeId: theme.id })
    } catch (err) {
      dispatch({ type: SWITCH_THEME_FAILURE, errorMessage: err.message })
    } finally {
      dispatch(setHasThemeLoaded(true))
    }
  }
}

async function loadThemeStylesheet(href: string) {
  return new Promise((resolve, reject) => {
    const currentStylesheetElement = document.getElementById('themeStylesheet')
    const stylesheetElement = document.createElement('link')
    if (currentStylesheetElement) {
      stylesheetElement.rel = 'stylesheet'
      stylesheetElement.id = 'themeStylesheet'
      stylesheetElement.href = href
      stylesheetElement.addEventListener('load', resolve, { once: true })
      currentStylesheetElement.replaceWith(stylesheetElement)
    } else if (process.env.NODE_ENV === 'test') {
      resolve('ok')
    } else {
      reject(new Error('No <link id="themeStylesheet"> element on the page'))
    }
  })
}
